import PageFooter from './PageFooter';

export * from './PageFooter';

export default PageFooter;
